import React from 'react';
import { Cell, Row } from 'react-table';

import { IconMusicNotes, DropdownInput } from '@trqk/components';

interface StatementWorkCellProps {
    cell: Cell<TrqkGapChannelAudio, GapWorkStatementWorkCellValue>;
    column: StatementWorkColumn;
    row: Row<TrqkGapChannelAudio>;
}

const noMatch = {
    id: null,
    label: '(No match)',
    value: null,
} as DropdownInputOption;

/**
 * Renders a DropdownInput that can be used to match a statement work to an audio file.
 * @param props - {@link StatementWorkCellProps}
 * @returns JSX
 */
export function StatementWorkCell({
    cell,
    column,
    row,
}: StatementWorkCellProps): JSX.Element {
    const width = (column?.width as number) ?? 100;
    const dropdownInputOptions = cell?.value?.dropdownInputOptions ?? [];
    const gapAudioId = cell?.value?.gapAudioId ?? null;
    const matchedWorkId = cell?.value?.matchedWorkId ?? null;
    const include = row?.isSelected ?? false;
    const { updateAudioMatch } = column;
    let optionLists = [[noMatch]];

    if (dropdownInputOptions.length > 0) {
        optionLists = [[noMatch], [...dropdownInputOptions]];
    }

    return (
        <DropdownInput
            // In other cells, we are graying out the text when there are un-applied changes to the
            // match selection. We want the dropdown to remain black, though, to indicate that it's
            // the control that changes the state of the rest of the row.
            addClasses="text-black"
            defaultId={matchedWorkId}
            elementId={gapAudioId}
            handleChange={(
                prevOption: DropdownInputOption | null,
                option: DropdownInputOption | null,
            ): void => {
                const songId = option?.id ?? null;

                if (prevOption?.id !== option?.id && gapAudioId) {
                    updateAudioMatch(gapAudioId, songId, include);
                }
            }}
            highlightIfSelected={false}
            optionLists={optionLists}
            resetTimestamp={matchedWorkId === null ? 0 : 1}
            sortOptionsList={false}
            StatusIcon={IconMusicNotes}
            width={width - 8} // this leaves us some space on the right side, equal to pr-2
        />
    );
}
